@if (isVisible) {
    <div class="col padding-horizontal-24">
        <div class="row">
            <div class="col">
                @if (generalAgreementRequired) {
                    <strong mark-required>{{ 'Rahmenvertrag' | translate }}</strong>
                } @else {
                    <strong>{{ 'Rahmenvertrag' | translate }}</strong>
                }
            </div>
        </div>
        <div class="row align-items-center mx-auto">
            <div class="col px-0">
                @if (editable) {
                    <select
                        class="form-select form-select-sm basket-supplier-frame-contract__select"
                        [class.is-invalid]="showRequiredButUnselectedError"
                        [formControl]="control"
                    >
                        @if (!generalAgreementRequired) {
                            <option [ngValue]="null">{{ 'Bitte wählen' | translate }}</option>
                        } @else if (!frameContractSelection) {
                            <option [ngValue]="null" disabled>{{ 'Bitte wählen' | translate }}</option>
                        }
                        @for (frameContract of frameContracts; track frameContract.id) {
                            <option
                                [ngValue]="frameContract.id"
                                [title]="frameContract.contractNumber + ' : ' + frameContract.title"
                            >
                                {{ frameContract.contractNumber }} : {{ frameContract.title }}
                            </option>
                        }
                    </select>
                    @if (showRequiredButEmptyWarning) {
                        <div class="alert alert-warning mt-2 mb-0 py-2 small">
                            {{ 'Kein gültiger Rahmenvertrag verfügbar – Bestellen ist gesperrt.' | translate }}
                        </div>
                    } @else if (showRequiredButUnselectedError) {
                        <div class="invalid-feedback d-block">
                            {{ 'Bitte einen Rahmenvertrag auswählen.' | translate }}
                        </div>
                    }
                } @else {
                    @if (frameContractSelection) {
                        <div [title]="frameContractSelection.contractNumber + ' : ' + frameContractSelection.title">
                            {{ frameContractSelection.contractNumber }} : {{ frameContractSelection.title }}
                        </div>
                    }
                }
            </div>
        </div>
    </div>
}
